// extracted by mini-css-extract-plugin
export default {"heading":"textComponents_heading__j5SAB","heading_2":"textComponents_heading_2__CizM7","paragraph":"textComponents_paragraph__8mUTc"};